<template>
  <nav>
    <span class="toolbar-title">
      <span class="toolbar-title-part">Bankszámla kalkulátor -&nbsp;</span
      ><wbr />
      <span class="toolbar-title-part">együttműködve a K&H Bankkal</span>
    </span>
  </nav>
</template>

<script>
import "./_vpd-toolbar.scss";

export default {};
</script>
